import { Button } from '@mui/material';
import { styled } from '@mui/system';

export const FilledButton = styled(Button)(
  ({ theme, background, fontFamily, height, width, disabled }) => {
    const optionalWidth = width ? { width } : {};
    return {
      background    : background ?? theme.palette.primary.blue1,
      color         : theme.palette.primary.white,
      borderRadius  : '8px',
      height        : height ?? '56px',
      ...optionalWidth,
      fontFamily    : fontFamily ?? 'Montserrat',
      fontStyle     : 'normal',
      fontWeight    : 700,
      fontSize      : '16px',
      lineHeight    : '20px',
      textTransform : 'none',
      '&:disabled'  : {
        opacity : 0.3,
        cursor  : 'not-allowed',
      },
      '&: hover' : {
        background : background ?? theme.palette.primary.blue1,
      },
      '&: disabled' : {
        background : background ?? theme.palette.primary.blue1,
        color      : theme.palette.primary.white,
      },
    };
  }
);
